/**
 *  @module Resources/Charges
 */
import { __assign, __awaiter, __extends, __generator } from "tslib";
import { HTTPMethod } from "../api/RestAPI.js";
import { ignoreDescriptor } from "./common/ignoreDescriptor.js";
import { CRUDResource } from "./CRUDResource.js";
export var ChargeStatus;
(function (ChargeStatus) {
    ChargeStatus["PENDING"] = "pending";
    ChargeStatus["SUCCESSFUL"] = "successful";
    ChargeStatus["FAILED"] = "failed";
    ChargeStatus["ERROR"] = "error";
    ChargeStatus["CANCELED"] = "canceled";
    ChargeStatus["AWAITING"] = "awaiting";
    ChargeStatus["AUTHORIZED"] = "authorized";
})(ChargeStatus || (ChargeStatus = {}));
var Charges = /** @class */ (function (_super) {
    __extends(Charges, _super);
    function Charges() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Charges.prototype.list = function (data, auth, callback, storeId) {
        return this.defineRoute(HTTPMethod.GET, "(/stores/:storeId)/charges")(data, callback, auth, { storeId: storeId });
    };
    Charges.prototype.create = function (data, auth, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, ignoreDescriptor(function (updatedData) {
                        return _this.defineRoute(HTTPMethod.POST, "/charges", Charges.requiredParams)(updatedData, callback, auth);
                    }, data)];
            });
        });
    };
    Charges.prototype.get = function (storeId, id, data, auth, callback) {
        return this._getRoute()(data, callback, auth, { storeId: storeId, id: id });
    };
    Charges.prototype.getIssuerToken = function (storeId, chargeId, data, auth, callback) {
        return this.defineRoute(HTTPMethod.GET, "/stores/:storeId/charges/:chargeId/issuerToken")(data, callback, auth, { storeId: storeId, chargeId: chargeId });
    };
    Charges.prototype.poll = function (storeId, id, data, auth, callback, 
    /**
     * Condition for the resource to be successfully loaded. Default to pending status check.
     */
    cancelCondition, successCondition, iterationCallback) {
        var _this = this;
        if (successCondition === void 0) { successCondition = function (_a) {
            var status = _a.status;
            return status !== ChargeStatus.PENDING;
        }; }
        var pollingData = __assign(__assign({}, data), { polling: true });
        var promise = function () { return _this.get(storeId, id, pollingData, auth); };
        return this.api.longPolling(promise, successCondition, cancelCondition, callback, undefined, undefined, iterationCallback);
    };
    Charges.requiredParams = ["transactionTokenId", "amount", "currency"];
    Charges.routeBase = "/stores/:storeId/charges";
    return Charges;
}(CRUDResource));
export { Charges };
//# sourceMappingURL=Charges.js.map